import React, { useEffect } from 'react';
import logger from '../utils/monitor-service';

const useScrollWithHashParam = (
  wrapperRef: React.RefObject<HTMLDivElement>
) => {
  useEffect(() => {
    if (wrapperRef.current) {
      const element = wrapperRef.current;
      const wrapperId = element.getAttribute('id');

      if (!wrapperId) {
        logger.logError('A wrapper needs an Id to be scrolled.');
      }

      const hasBookParam = window.location.hash.includes(`#${wrapperId}`);

      if (hasBookParam) {
        wrapperRef.current?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [wrapperRef]);
};

export default useScrollWithHashParam;
